<template>
  <div>
    <!-- <div class="menu">
      <div class="menu__create">
          <span @click="createAi">+ 创建 AI</span>
      </div>
      <div class="menu__item" v-for="menu in menuItems" :key="menu.id" >
        <router-link class="menu__item__link" :to="menu.path">
          <span style="margin-right: 10px;"><i :class="menu.icon"></i></span>
          <span>{{menu.name}}</span>
        </router-link>
      </div>
    </div> -->
    <el-menu
      :default-active="this.$router.path"
      class="menu-vertical el-menu-vertical-demo"
      @select="handleSelect"
      menu-trigger="click"
      :router="true"
      text-color="#fff"
      background-color="#062141"
      active-text-color="#2f54eb">
      <div class="menu-vertical__create">
        <span @click="createAi">+ 创建 AI</span>
      </div>
      <template v-for="(menu, index) in menuItems">
        <!--无子菜单处理-->
        <template v-if="menu.children.length == 0">
          <el-menu-item :index="menu.path">
            <i :class="menu.icon"></i>
            <span style="font-size: 16px;">{{menu.name}}</span>
          </el-menu-item>
        </template>
        <!--有子菜单处理-->
        <template v-else>
          <el-submenu :index="index.toString()">
            <template slot="title">
              <i :class="menu.icon"></i>
              <span style="font-size: 16px;">{{menu.name}}</span>
            </template>
            <el-menu-item-group>
              <template v-for="menu2 in menu.children">
                <el-menu-item :index="menu2.path">{{menu2.name}}</el-menu-item>
              </template>
            </el-menu-item-group>
        </el-submenu>
        </template>
      </template>
    </el-menu>
  </div>
</template>
<script>
  export default {
    name: 'AI-Menu',
    data() {
      return {
        activeIndex: '1',
        drawer: false, // 创建AI抽屉
        menuItems: [],
      };
    },
    mounted(){
      this.getMenuList()
    },
    methods: {
      handleSelect(key, keyPath) {
        console.log(key, keyPath);
      },
      getMenuList() {
        this.$http.get('/aigenai/menu/list').then(
          res => {
            if (res.code !== 0) return
            this.menuItems.push(...res.data)
          }
        )
      },
      createAi() {
        this.$bus.$emit('createAi', this.drawer = true)
      }
    },
  }
</script>
  
<style lang="less" scoped>
  .menu-vertical {
    position: absolute;
    width: 250px;
    height: 100%;
    left: 0;
    top: 64px;
    /* background-color: #062141; */
    &__create{
      width: 200px;
      height: 50px;
      margin: 20px auto;
      background-color: #2f54eb;
      border-radius: 60px;
      cursor: pointer;
      >span{
        display: block;
        color: rgb(255, 255, 255);
        text-align: center;
        line-height: 45px;
      }
    }
  }
</style>